import { usePostMutation } from "@/api/swr/useMutation";
import { z } from "zod";

type Config = Parameters<typeof usePostMutation<z.ZodUndefined, z.ZodNull>>[3];

export const useConfirmPendingAssessment = (id: string, config?: Config) => {
  return usePostMutation(
    z.undefined(),
    z.null(),
    `/console/pending_assessments/${id}`,
    config,
  );
};
